import React, { useContext, useEffect } from "react";
import environment from "../../../../../RelayEnvironment";
import { graphql, QueryRenderer } from "react-relay";
import ItemSelection from "../ItemSelection";
import { GreenMachineContext } from "../GreenMachineContext";
import "./SelectSport.css";

const GET_ACTIVE_SPORTS = graphql`
  query SelectSportQuery {
    sportsWithSlates {
      id
      name
    }
  }
`;

export default function SelectSport() {
  const {
    setSelectedSportID,
    setSelectedSportName,
    STAGE_NUMBERS,
    currentStage,
    updateCurrentStage,
  } = useContext(GreenMachineContext);

  function handleSportSelect(e, sport) {
    e.preventDefault();

    setSelectedSportID(sport.id);
    setSelectedSportName(sport.name);

    updateCurrentStage();
  }

  // Cross-stage navigation (back/Start Over/jump) now lives in the ChevronBar,
  // so this step only renders its picker on the first stage.
  if (currentStage !== STAGE_NUMBERS.selectSport) {
    return null;
  }

  return (
    <QueryRenderer
      environment={environment}
      query={GET_ACTIVE_SPORTS}
      variables={{}}
      render={({ error, props }) => {
        if (error) {
          return <div>Something went wrong.</div>;
        }

        if (!props) {
          return <></>;
        }

        return (
          <div className="gm-select-sport-container">
            {props.sportsWithSlates && props.sportsWithSlates.length > 0 ? (
              <ItemSelection
                items={props.sportsWithSlates}
                onClick={handleSportSelect}
              />
            ) : (
              <NoActiveSlatesNotice />
            )}
          </div>
        );
      }}
    />
  );
}

// Flags the empty state in context so the step heading can reflect it.
// Renders nothing itself — the messaging lives in the heading.
function NoActiveSlatesNotice() {
  const { setActiveSlatesExist } = useContext(GreenMachineContext);

  useEffect(() => {
    setActiveSlatesExist(false);
    return () => setActiveSlatesExist(true);
  }, [setActiveSlatesExist]);

  return null;
}
